export const JarvisTheme = {
  colors: {
    bg0: "#060B12",
    bg1: "#0B1320",
    panel: "rgba(12, 18, 30, 0.72)",
    panelSoft: "rgba(12, 18, 30, 0.55)",
    panelBorder: "rgba(88, 230, 255, 0.18)",
    text: "rgba(235, 245, 255, 0.92)",
    muted: "rgba(196, 225, 240, 0.72)",
    accent: "#58E6FF",
    accentSoft: "rgba(88, 230, 255, 0.16)",
    accentBorder: "rgba(88, 230, 255, 0.25)",
    accentTrack: "rgba(88, 230, 255, 0.10)",
  },
  fonts: {
    ui: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial',
    mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },
  effects: {
    panelShadow:
      "0 20px 60px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.05)",
  },
} as const;

